<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Map" pageTitle="Map" />
            <MapContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import MapContent from '../Map/MapContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'MapPage',
    components: {
        MainHeader,
        PageTitle,
        MapContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>